import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Dce from "dce-engine/lib/decorators/Dce";

interface SmsFormProps {
    textarea: string
}

@Dce("SmsForm")
export default class SmsForm extends DceComponent<SmsFormProps> {

    private textarea: HTMLTextAreaElement;

    constructor(elem: DceHTMLElement, props: SmsFormProps) {
        super(elem, props);
        this.textarea = this.elem.querySelector(this.props.textarea) as HTMLTextAreaElement;
    }

    public setTemplate(e: Event, elem: HTMLElement){
        console.log("XXXXXXXXXXXXXX", elem);
        let sms = elem.getElementsByTagName('template').item(0).content.textContent;
        this.textarea.value = sms;
    }


}